import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import { DialogPropsBase } from '../../common/props/commonFormProps';
import { renderNewTextField, renderCheckbox, renderErrorInfoText } from '../../common/forms/FieldCreators';
import { LocalForm, Control, Errors } from 'react-redux-form';
import nameof from '../../utils/nameof';
import { localizations } from '../../localization/localization';
import { PhoneNumberSettingsModel } from '../../common/models/CommonModels';
import * as formValidators from '../../common/validators/formValidators'

type SubmitType = (data: PhoneNumberSettingsModel) => void;
type CancelType = () => void;

interface EditProps {
    model?: PhoneNumberSettingsModel
}

const initialState: PhoneNumberSettingsModel = { id: undefined, phoneNumber: "", phoneDetails: "", phoneVisible: true }

type AddProps = DialogPropsBase<SubmitType, CancelType> & EditProps

const AddEditPhoneNumberDialog: React.SFC<AddProps> = (props) => {

    const editMode = !!props.model;

    return (
        <Dialog open={props.isOpen}>
            <LocalForm
                hideNativeErrors
                onSubmit={(values) => props.onSubmit(values)}
                initialState={props.model || initialState}
            >
                <DialogTitle>{editMode ? localizations.forms.editPhone : localizations.forms.addPhone }</DialogTitle>
                <DialogContent>
                    <Grid container direction="column" spacing={2}>
                        <Grid item>
                            <Control.text
                                model={`.${nameof<PhoneNumberSettingsModel>("phoneNumber")}`}
                                required
                                component={renderNewTextField}
                                label= {localizations.common.phoneNumber}
                                validators={{
                                    isRequired: formValidators.required,
                                    isPhoneNumber: formValidators.isPhoneNumber,
                                }}
                                validateOn={["blur", "change"]}
                            />
                            <Errors model={`.${nameof<PhoneNumberSettingsModel>("phoneNumber")}`} 
                                messages={{
                                    isRequired: localizations.validation.required,
                                    isPhoneNumber: localizations.validation.notAPhoneNumber,
                                   }}
                                wrapper={renderErrorInfoText}
                                show={{ touched: true, focus: false }}
                            />
                        </Grid>
                        <Grid item>
                            <Control.text
                                model={`.${nameof<PhoneNumberSettingsModel>("phoneDetails")}`}
                                component={renderNewTextField}
                                label= {localizations.common.definition}
                            />
                        </Grid>
                        <Grid item>
                            <FormControlLabel
                                control={
                                    <Control.checkbox
                                        model={`.${nameof<PhoneNumberSettingsModel>("phoneVisible")}`}
                                        component={renderCheckbox}
                                    />
                                }
                                label={localizations.settings.phoneNumberVisible}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" type="submit">
                        {editMode ? localizations.actions.save : localizations.actions.add}
                    </Button>
                    <Button variant="outlined" onClick={() => props.onCancel()}>
                        {localizations.actions.cancel}
                    </Button>
                </DialogActions>
            </LocalForm>
        </Dialog>
    );
}

export default AddEditPhoneNumberDialog;


// WEBPACK FOOTER //
// ./src/account/forms/AddEditPhoneNumberDialog.tsx